<!-- HEADER -->
<ng-container>
  <div class="gb_pre_head">
    <div class="container">
      <div class="row">
        <div class="col-12 d-flex align-items-center justify-content-end">
          &nbsp;
        </div>
      </div>
    </div>
  </div>
  <div id="gb_breadcrumb">
    <div class="container">
      <div class="row">
        <div class="col-12 d-flex justify-content-between">
          <div class="gb_welcomeside">
            <ul class="gb_bcrumb">
              <li>
                <a href="javascript:void(0);" [routerLink]="['/']">Home</a>
              </li>
            </ul>
          </div>
          <div class="gb_pepPAloghiSide">
            <img src="./assets/gb/img/logo-pap.svg" alt="Plug&Pay" width="451" height="293" aria-label="Plug" />
            <svg viewBox="0 0 72 48">
              <title>PagoPA</title>
              <path class="st0" d="M50.7,14.4l0,6.1h-4.4V0h4.4h0.5h3.2c2.6,0,3.9,0.7,4,2.1v10c0,1.4-1.3,2.1-3.8,2.1h-3.8L50.7,14.4L50.7,14.4z M54,2.4h-3.3v9.5H54V2.4z" />
              <path class="st0" d="M3.7,20.5l0,6.1H0V6.1h3.7h0.4h2.7c2.2,0,3.3,0.7,3.3,2.1v10c0,1.4-1.1,2.1-3.2,2.1H3.7V20.5z M6.5,8.5H3.7v9.5h2.8V8.5z" />
              <path class="st0" d="M21.5,20.3h-7c-2.1,0-3.1-0.7-3.1-2.1l0-4.2c0-1.4,1.1-2.1,3.2-2.1h3.2V8.5h-2.8l0,1.9h-3.6V8.2c0-1.4,1.1-2.1,3.2-2.1l3.6,0c2.1,0,3.2,0.7,3.2,2.1V20.3z M15.1,17.9h2.8l0-3.7h-2.8V17.9z" />
              <path class="st0" d="M29.6,20.3h-3.2c-2.1,0-3.2-0.7-3.2-2.1v-10c0-1.4,1.1-2.1,3.3-2.1h2.7h0.5h3.7v18.3c0,1.4-1.1,2.1-3.2,2.1h-3.7c-2.1,0-3.2-0.7-3.2-2.1v-2.1h3.7v1.9h2.8v-3.7L29.6,20.3z M26.8,17.9h2.8V8.5h-2.8V17.9z" />
              <path class="st0" d="M44.7,18.2c0,1.4-1.1,2.1-3.3,2.1h-3.6c-2.2,0-3.2-0.7-3.2-2.1v-10c0-1.4,1.1-2.1,3.2-2.1h3.7c2.1,0,3.2,0.7,3.2,2.1L44.7,18.2L44.7,18.2z M41,8.5h-2.8v9.5H41L41,8.5z" />
              <path class="st0" d="M72,2.2c0-1.4-1.3-2.1-3.8-2.1h-4.4c-2.6,0-3.9,0.7-3.9,2.1v18.3h4.4v-6.2h3.3v5.2c0,13.4-10.7,24.2-24,24.2c-7.7,0-14.6-3.7-19-9.3l2.2-1.7l-8.8-6l0.4,12.6l2.8-2.3c5.2,6.7,13.3,11,22.4,11C59.3,48,72,35.2,72,19.4L72,2.2z M67.6,11.9h-3.3V2.5h3.3V11.9z" />
            </svg>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div id="gb_mobimenu" class="gb_entemobimenu" aria-labelledby="gb_focusableMenu">
    <div class="gb_menucont">
      <div class="gb_headMenuMobiEnte">
        <div class="gb_EnteName">
          <a href="javascript:void(0);" [routerLink]="['/']">Home</a>
        </div>
      </div>
      <div class="gb_pepPAloghiSide">
        <img src="./assets/gb/img/logo-pap.svg" alt="Plug&Pay" width="451" height="293" aria-label="Plug" />
        <svg viewBox="0 0 72 48">
          <title>PagoPA</title>
          <path class="st0" d="M50.7,14.4l0,6.1h-4.4V0h4.4h0.5h3.2c2.6,0,3.9,0.7,4,2.1v10c0,1.4-1.3,2.1-3.8,2.1h-3.8L50.7,14.4L50.7,14.4zM54,2.4h-3.3v9.5H54V2.4z" />
          <path class="st0" d="M3.7,20.5l0,6.1H0V6.1h3.7h0.4h2.7c2.2,0,3.3,0.7,3.3,2.1v10c0,1.4-1.1,2.1-3.2,2.1H3.7V20.5z M6.5,8.5H3.7v9.5h2.8V8.5z" />
          <path class="st0" d="M21.5,20.3h-7c-2.1,0-3.1-0.7-3.1-2.1l0-4.2c0-1.4,1.1-2.1,3.2-2.1h3.2V8.5h-2.8l0,1.9h-3.6V8.2c0-1.4,1.1-2.1,3.2-2.1l3.6,0c2.1,0,3.2,0.7,3.2,2.1V20.3z M15.1,17.9h2.8l0-3.7h-2.8V17.9z" />
          <path class="st0" d="M29.6,20.3h-3.2c-2.1,0-3.2-0.7-3.2-2.1v-10c0-1.4,1.1-2.1,3.3-2.1h2.7h0.5h3.7v18.3c0,1.4-1.1,2.1-3.2,2.1h-3.7c-2.1,0-3.2-0.7-3.2-2.1v-2.1h3.7v1.9h2.8v-3.7L29.6,20.3z M26.8,17.9h2.8V8.5h-2.8V17.9z" />
          <path class="st0" d="M44.7,18.2c0,1.4-1.1,2.1-3.3,2.1h-3.6c-2.2,0-3.2-0.7-3.2-2.1v-10c0-1.4,1.1-2.1,3.2-2.1h3.7c2.1,0,3.2,0.7,3.2,2.1L44.7,18.2L44.7,18.2z M41,8.5h-2.8v9.5H41L41,8.5z" />
          <path class="st0" d="M72,2.2c0-1.4-1.3-2.1-3.8-2.1h-4.4c-2.6,0-3.9,0.7-3.9,2.1v18.3h4.4v-6.2h3.3v5.2c0,13.4-10.7,24.2-24,24.2c-7.7,0-14.6-3.7-19-9.3l2.2-1.7l-8.8-6l0.4,12.6l2.8-2.3c5.2,6.7,13.3,11,22.4,11C59.3,48,72,35.2,72,19.4L72,2.2z M67.6,11.9h-3.3V2.5h3.3V11.9z" />
        </svg>
      </div>
    </div>
  </div>
</ng-container>
<!-- CONTENT -->
<ng-container>
  <div class="container">
    <div class="row">
      <div class="col-md-12 text-center py-5">
        <div class="mb-1">
          <h1>404</h1>
          <hr />
          <h2>{{"resource-not-found" | translate}}</h2>
        </div>
      </div>
    </div>
  </div>
</ng-container>
<!-- FOOTER -->
<ng-container>
  <footer class="gb_enteFooter">
    <div class="container">
      <div class="row">
        <div class="col d-flex flex-wrap flex-column flex-md-row justify-content-between">
          <div class="gb_footLeftside w-50">
            <div class="gb_pagoPALogofoot">
              <svg viewBox="0 0 72 48">
                <title>PagoPA</title>
                <path class="st0" d="M50.7,14.4l0,6.1h-4.4V0h4.4h0.5h3.2c2.6,0,3.9,0.7,4,2.1v10c0,1.4-1.3,2.1-3.8,2.1h-3.8L50.7,14.4L50.7,14.4z   M54,2.4h-3.3v9.5H54V2.4z" />
                <path class="st0" d="M3.7,20.5l0,6.1H0V6.1h3.7h0.4h2.7c2.2,0,3.3,0.7,3.3,2.1v10c0,1.4-1.1,2.1-3.2,2.1H3.7V20.5z M6.5,8.5H3.7v9.5  h2.8V8.5z" />
                <path class="st0" d="M21.5,20.3h-7c-2.1,0-3.1-0.7-3.1-2.1l0-4.2c0-1.4,1.1-2.1,3.2-2.1h3.2V8.5h-2.8l0,1.9h-3.6V8.2  c0-1.4,1.1-2.1,3.2-2.1l3.6,0c2.1,0,3.2,0.7,3.2,2.1V20.3z M15.1,17.9h2.8l0-3.7h-2.8V17.9z" />
                <path class="st0" d="M29.6,20.3h-3.2c-2.1,0-3.2-0.7-3.2-2.1v-10c0-1.4,1.1-2.1,3.3-2.1h2.7h0.5h3.7v18.3c0,1.4-1.1,2.1-3.2,2.1  h-3.7c-2.1,0-3.2-0.7-3.2-2.1v-2.1h3.7v1.9h2.8v-3.7L29.6,20.3z M26.8,17.9h2.8V8.5h-2.8V17.9z" />
                <path class="st0" d="M44.7,18.2c0,1.4-1.1,2.1-3.3,2.1h-3.6c-2.2,0-3.2-0.7-3.2-2.1v-10c0-1.4,1.1-2.1,3.2-2.1h3.7  c2.1,0,3.2,0.7,3.2,2.1L44.7,18.2L44.7,18.2z M41,8.5h-2.8v9.5H41L41,8.5z" />
                <path class="st0" d="M72,2.2c0-1.4-1.3-2.1-3.8-2.1h-4.4c-2.6,0-3.9,0.7-3.9,2.1v18.3h4.4v-6.2h3.3v5.2c0,13.4-10.7,24.2-24,24.2  c-7.7,0-14.6-3.7-19-9.3l2.2-1.7l-8.8-6l0.4,12.6l2.8-2.3c5.2,6.7,13.3,11,22.4,11C59.3,48,72,35.2,72,19.4L72,2.2z M67.6,11.9h-3.3  V2.5h3.3V11.9z" />
              </svg>
              <span>
                <strong>{{"generic.labels.pagopa.title" | translate}}</strong>
                {{"generic.labels.pagopa.subtitle" | translate}}
              </span>
            </div>
            <div class="gb_tagpagoPA text-center text-lg-start">
              {{"generic.labels.pagopa.description" | translate}}
              <a href="https://www.pagopa.gov.it/" target="_blank" rel="noopener" title="pagoPA" tabindex="0"
                aria-label="pagoPA"> {{"generic.buttons.seeMore" | translate}}</a>
            </div>
          </div>
          <div class="gb_footRightside w-50">
            <span>{{"generic.labels.psp" | translate}}</span>
            <a href="https://www.pagopa.gov.it/it/prestatori-servizi-di-pagamento/elenco-PSP-attivi/" class="gb_btncta w"
              target="_blank" rel="noopener" tabindex="0" title="{{'generic.buttons.psp' | translate}}"
              attr.aria-label="{{'generic.buttons.psp' | translate}}">
              {{"generic.buttons.psp" | translate}}
              <svg viewBox="0 0 24 24">
                <path
                  d="M12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4ZM2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12ZM12.2929 7.29289C12.6834 6.90237 13.3166 6.90237 13.7071 7.29289L17.7071 11.2929C18.0976 11.6834 18.0976 12.3166 17.7071 12.7071L13.7071 16.7071C13.3166 17.0976 12.6834 17.0976 12.2929 16.7071C11.9024 16.3166 11.9024 15.6834 12.2929 15.2929L14.5858 13H7C6.44772 13 6 12.5523 6 12C6 11.4477 6.44772 11 7 11H14.5858L12.2929 8.70711C11.9024 8.31658 11.9024 7.68342 12.2929 7.29289Z">
                </path>
              </svg>
            </a>
          </div>
        </div>
      </div>
    </div>
  </footer>
</ng-container>
